<template>
  <div class="auth-wrapper auth-v2">
    <div class="w-100 d-flex flex-column justify-content-between">
      <div class="px-2">
        <HeaderBar/>
        <div
          class="d-flex flex-column mb-2 mt-4"
          style="font-size: 15px; font-weight: 500"
        >
          <div class="add-economic-record-title1 mt-2 text-center">Editar Animal</div>
        </div>
        <validation-observer ref="GanForm">
          <b-form @submit.prevent="" >
          <div class="d-flex align-items-center justify-content-center">
            <div class="flex-column pt-0 mr-2">Macho</div>
            <div class="align-self-end mr-2">
              <b-form-radio
              v-model="animal.sex"
              button-variant="#D7B92C"
              value="0"
              class=""
              name="check-button"
            />
            </div>
            <div class="flex-column">Hembra</div>
            <div class="align-self-end mr-2">
              <b-form-radio
                v-model="animal.sex"
                button-variant="#D7B92C"
                value="1"
                class=""
                name="check-button"
              />
            </div>
          </div>
          <b-form-group label="Nombre" label-for="name">
            <validation-provider
              #default="{ errors }"
              name="Nombre"
              rules="required"
            >
              <b-form-input id="name" v-model="animal.name" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <div class="d-flex">
            <b-form-group label="Número" label-for="number" class="mr-1">
              <validation-provider
                #default="{ errors }"
                name="Número"
                rules="required"
              >
                <b-form-input id="number" type="number" ref="animalNumber" v-model="animal.number" @focusout="valAnimalNumber" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="SIRIGABB" label-for="name">
              <validation-provider
                #default="{ errors }"
                name="SIRIGABB"
                :rules="{regex: '^([0-9]{7})$'}"
              >
                <b-form-input id="name" v-model="animal.sirigap" @focus="sirigabbSelector"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <b-modal size="sm" centered v-model="modalShow" hide-footer hide-header>
            <div>
                <div class="d-flex justify-content-center mt-1 mb-2 text-justify">
                    <h3>Introduzca los 7 números reflejados en la etiqueta del animal.</h3>
                </div>
                <div class="d-flex justify-content-center mt-1 mb-2 text-center">
                    <img src="@/assets/images/ganImage/SIRIGABB.png"  width="350" alt="">
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="SIRIGABB"
                  :rules="{regex: '^([0-9]{7})$'}"
                >
                  <b-form-input id="sirigapp" v-model="animal.sirigap"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <div class="d-flex justify-content-center mt-1 mb-2 text-justify">
                  <b-button @click="modalShow=false" class="bg-primary w-75 mt-2 " block>
                    Aceptar
                  </b-button>
                </div>   
            </div>
        </b-modal>
          <b-form-group>
            <div class="d-flex">
              <div class="mr-1">
                <b-form-radio
                  v-model="selected"
                  name="some-radios"
                  value="A"
                  >Nacimiento
                </b-form-radio>
                <b-form-datepicker id="fecha_nac" name="fecha_nac" v-model="bornDate" 
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              :min="minCfgDate" :max="maxCfgDate" @change="dateSelected"
              locale="es-ES"/>
                
              </div>
              <div>
                <b-form-radio
                  v-model="selected"
                  name="some-radios"
                  value="A"
                  >Edad Aprox:</b-form-radio
                >
                <b-form-input type="number" v-model="animalAge" @input="setAge"/>
              </div>
            </div>
          </b-form-group>
          <div class="d-flex">
            <b-form-group label="Madre" label-for="madre" class="mr-1 w-50">
              
              <validationProvider
                #default="{ errors }"
                name="Madre"
              >
                <b-form-select v-if="momInFarm" id="madre" name="madre" v-model="animal.mother" :options="femalesOptions" :value="femalesOptions.value"/>
                <b-form-input  v-if="!momInFarm" id="madre" name="madre" v-model="animal.mother"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validationProvider>
              <b-form-checkbox v-model="momInFarm">Madre en finca</b-form-checkbox>
            </b-form-group>
            <b-form-group label="Padre" label-for="padre" class="w-50">
              <validationProvider
                #default="{ errors }"
                name="Padre"
              >
                <b-form-select v-if="dadInFarm" id="padre" name="padre" v-model="animal.father" :options="malesOptions" :value="malesOptions.value" class="w-100"/>
                <b-form-input v-if="!dadInFarm" id="padre" name="padre" v-model="animal.father" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validationProvider>
              <b-form-checkbox v-model="dadInFarm">Padre en finca</b-form-checkbox>
            </b-form-group>
          </div>
          <div class="d-flex ">
          
            <b-form-group label="Peso (opcional)" label-for="weight" class="w-50 mr-1">
              <validationProvider
                #default="{ errors }"
                name="Peso"
                rules="required"
              >
              <b-form-input id="weight" name="weight" v-model="animal.weight"  type="number" min="0" max="2000" onkeyup="if(value>2000) value=2000;"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validationProvider>
            </b-form-group>

            <b-form-group label="Raza (opcional):" label-for="race" 
            class="">
              <b-form-select id="race" v-model="animal.batch_id" :options="raceOptions" :value="raceOptions.value" />
            </b-form-group>
          </div>
         
        <div class="row justify-content-center text-center align-items-center ">
          <div class=" col-12">
            <span>Subir archivo </span>
            <span> o foto:</span>
          </div>
          <div>
            <div class="col-12">
              <b-img :src="featured" @click="uploadImage" :width="imgWidth"></b-img>
              <b-form-file 
                ref="FileUpload"
                v-model="fileU" style="display: none;"
                accept="image/jpeg, image/png"
                plain/>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center pbbuton">
          <b-button @click="EditAnimal" class="bg-primary w-75 mt-2 " block :disabled="isPost">Incluir Animal</b-button>
        </div>
           </b-form>
        </validation-observer>
      </div>
    </div>
    <ControlMenu />
  </div>
</template>


<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BImg,
  BFormFile,
  BFormGroup,
  BForm,
  BButton,
  BFormSelect,
  BFormInput,
  BFormRadio,
  BFormCheckbox,
  BFormDatepicker
} from "bootstrap-vue";
import ControlMenu from "@/components/ControlMenu.vue";
import axios from "axios";
import HeaderBar from '@/components/HeaderBar.vue'
import vSelect from "vue-select"
import { MonthPickerInput } from 'vue-month-picker'
import "vue-select/dist/vue-select.css";
import { required } from "@validations";
import imageFile from "@/assets/images/ganImage/image 177.svg"
//import EditAnimal from "../DataLog/Animal/EditAnimal.vue";
export default {
  components: {
    ValidationProvider,
    vSelect,
    required,
    BFormRadio,
    ValidationObserver,
    BRow,
    BCol,
    BLink,
    BImg,
    BFormFile,
    BForm,
    BButton,
    BFormSelect,
    BFormInput,
    ControlMenu,
    HeaderBar,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormDatepicker,
    MonthPickerInput,
    imageFile
  },
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    // 15th two months prior
    const minDate = new Date(today)
    minDate.setMonth(minDate.getMonth() - 500)
    minDate.setDate(15)
    // 15th in two months
    const maxDate = new Date(today)
    maxDate.setMonth
    maxDate.setMonth(maxDate.getMonth())
    maxDate.setDate(maxDate.getDate())
    return {  
      currAnimal: 0, 
      dadInFarm:false,
      momInFarm:false,
      rows:[],
      isPost:false,
      modalShow:false,
      selected: false,
      dateFormat:'%n/%Y',
      maxCfgDate:maxDate,
      minCfgDate:minDate,
      setLang:'es',
      raceOptions:[],
      featured:imageFile,
      bornDate:now,
      animalAge:0,
      animalData:[],
      animal:{},
      /* animal:{
        name:"",
        number:"",
        sirigap:"",
        weight:0,
        age:0,
        sex:false,
        mother:"",
        father:"",
        dad:"",
        image_url:"",
        birthdate:"",
        buy_date:now,
        farm_id:localStorage.getItem('currentFarm'),
        state:1,
        price:0,
        batch_id:'Otro'
      }, */
      fileU:null,
      imgWidth:null,
      femalesOptions:[],
      malesOptions:[],
    };
  },
  methods: {
     async fetchAnimalData(config){
      let id= parseInt(this.$route.params.id);
      console.log("ID:",id)
      fetch(this.$apiUrl+"view/animals/"+id, config)
        .then(response => response.json())
        .then(result => {
            //this.animalData = result.animals;
            this.animal= result.animals;
            console.log("Result",result.animals)
            console.log("Name:",this.animal.name)
            if(Number.isInteger(this.animal.father)){
              console.log('enfinca');
              console.log(Number.isInteger(this.animal.father));
              this.dadInFarm=true;
            }
            if(Number.isInteger(this.animal.mother)){
              this.momInFarm=true;
            }
        })
    },
    async fetchMales(config){
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/animals?recperpage=all&state=1&sex=0&farm_id="+farmId, config)
        .then(response => response.json())
        .then(result => {
          console.log(result.animals);
          this.malesOptions = result.animals.map(item => {return {value:item.id,text:item.number+' '+item.name}});
        })
      },
      async fetchFemales(config){
        let farmId= localStorage.getItem('currentFarm');
        fetch(this.$apiUrl+"list/animals?recperpage=all&state=1&sex=1&farm_id="+farmId, config)
        .then(response => response.json())
        .then(result => {
          console.log(result.animals);
          this.femalesOptions = result.animals.map(item => {return {value:item.id,text:item.number+' '+item.name}});
        })
      },

    async fetchRace(config) {
        fetch(this.$apiUrl+"list/animal_batches", config)
        .then(response => response.json())
        .then(result => {
            
            this.raceOptions= result.animal_batches.map(item=>{return {value : item.id, text:item.name }});
            //this.raceOptions = result.animal_batches.map(item => item.name)
        })
    },



    uploadImage(){
      this.$refs['FileUpload'].$el.click();
    },
    dateSelected(){
        console.log(this.bornDate);
        let nowDate= new Date;
        let newDate= new Date(this.bornDate);
        this.animal.birthdate= newDate;
        let age= this.monthDiff(newDate, nowDate);
        this.animal.age= parseInt(age);
        this.animalAge=parseInt(age);
        console.log(newDate);
        console.log(age);
     },
    setAge(){
      this.animal.age= this.animalAge;
    },
    monthDiff(d1, d2) {
      let months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },
    sirigabbSelector(){
      console.log('input')
      this.$refs.animalNumber.focus();
      this.modalShow=true;
    },
    valAnimalNumber(e){
      let self=this;
      console.log(e.target.value);
        this.rows.filter(function(x){
          if(x.number==e.target.value){
            self.$swal({
                title: 'Registro de Animal',
                text: 'El numero de animal ya existe',
                type: 'warning',
                icon:'warning',
                showCancelButton: false,
                confirmButtonColor:'#5E8F23',
                showCloseButton: true,
                showLoaderOnConfirm: false  
              }).then(function(){
                self.animal.number=null;
              });
          }
        })
    },
    EditAnimal() {
      this.$refs.GanForm.validate().then(success => {
        if(success){
          let id= parseInt(this.$route.params.id);
          this.isPost=true;
          const token = localStorage.getItem("accessToken");
          const config = {headers: {"X-Authorization": `Bearer ${token}`}};
          let self= this;
          if(this.fileU!=null){
            let formData=new FormData();
            formData.append('file', this.fileU);
            formData.append('fileName', this.filename);
            axios.post(this.$fileUpUrl, formData,
            {
              headers: {
                "Authorization": "Basic cHJpdmF0ZV9XVXVROG1DQncxV210WHc1empIa3NGQkNZQ1E9Og==",
                'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'
              }
            }).then(function(result){
              
              console.log(result);
              self.animal.image_url=result.data.url;
              console.log('animal post');
              console.log(self.animal);
              let animaldata={
                  name:self.animal.name,
                  number:self.animal.number,
                  sirigap:self.animal.sirigap,
                  weight:self.animal.weight,
                  age:self.animal.age,
                  sex:self.animal.sex,
                  image_url:self.animal.image_url,
                  mother:self.animal.mother,
                  father:self.animal.father,
                  birthdate:self.animal.birthdate,
              }
              self.$http.post("edit/animals/"+id, animaldata, config).then((response)=>{
                console.log(response);
                self.animal={
                  name:"",
                  number:"",
                  sirigap:"",
                  weight:0,
                  age:0,
                  sex:false,
                  image_url:"",
                  mother:"",
                  father:"",
                  birthdate:"",
                  buy_date:"",
                  state:0,
                  price:0,
                  farm_id:localStorage.getItem('currentFarm'),
                  batch_id:0
                }
                self.$swal({
                  title: 'Actualización de Animal',
                  text: 'Se editó animal de manera satisfactoria',
                  type: 'success',
                  icon:'success',
                  showCancelButton: false,
                  confirmButtonColor:'#5E8F23',
                  showCloseButton: true,
                  showLoaderOnConfirm: false  
                }).then(function(){
                  history.back();
                });
              }).catch(error => {
                console.log(error)
              });
            })
          }else{
            let animaldata={
                  name:self.animal.name,
                  number:self.animal.number,
                  sirigap:self.animal.sirigap,
                  weight:self.animal.weight,
                  age:self.animal.age,
                  sex:self.animal.sex,
                  //image_url:self.animal.image_url,
                  mother:self.animal.mother,
                  father:self.animal.father,
                  birthdate:self.animal.birthdate,
              }
            this.$http.post("edit/animals/"+id, animaldata, config).then((response)=>{
              console.log(response);
              this.animal={
                name:"",
                number:"",
                sirigap:"",
                weight:0,
                age:0,
                sex:false,
                image_url:"",
                mother:"",
                father:"",
                image1:"",
                image2:"",
                image3:"",
                birthdate:"",
                buy_date:"",
                state:1,
                price:0,
                farm_id:localStorage.getItem('currentFarm'),
                batch_id:0
              }
              self.$swal({
                title: 'Actualización de Animal',
                text: 'Se editó animal de manera satisfactoria',
                type: 'success',
                icon:'success',
                showCancelButton: false,
                confirmButtonColor:'#5E8F23',
                showCloseButton: true,
                showLoaderOnConfirm: false  
              }).then(function(){
                history.back();
              });
            }).catch(error => {
              console.log(error)
            });
          }
        }
      })
    },

  },
  watch:{
      'fileU':function(value){
        this.imgWidth=200;
        this.featured=URL.createObjectURL(this.fileU);
        console.log(value);
      },
      'bornDate':function(value){
        this.dateSelected();
      }
  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    this.fetchAnimalData(config);
    this.fetchRace(config);  
    this.fetchFemales(config);
    this.fetchMales(config);
  },



}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
